export const TREE_FIELD_TYPE = 'tree';
export const SELECT_FIELD_TYPE = 'select';
